import api from './api';

function unwrap(response, fallback) {
  const body = response?.data || {};
  if (body.error || body.code !== 200) throw new Error(body.message || fallback);
  return body.dataset?.data;
}

export async function fetchAssessmentPlans({ stateId = 0, quizId = 0, seriesId = 0 } = {}) {
  return unwrap(await api.get('/exam-courses/exam-quiz-plans', { params: {
    states_id: Number(stateId) || 0,
    ...(Number(quizId) > 0 ? { quiz_id: Number(quizId) } : {}),
    ...(Number(seriesId) > 0 ? { test_series_id: Number(seriesId) } : {}),
  } }), 'Unable to load assessment plans.') || {};
}

export async function fetchUserAssessmentPlans() {
  let response;
  try {
    response = await api.get('/exam-courses/get-user-exam-quiz-plans');
  } catch (error) {
    if (/no active exam quiz plans found/i.test(error.message || '')) return [];
    throw error;
  }
  if (/no active exam quiz plans found/i.test(response?.data?.message || '')) return [];
  const data = unwrap(response, 'Unable to load your assessment subscriptions.');
  return Array.isArray(data) ? data : [];
}

export async function fetchAssessmentPlanDetail({ stateId = 0, planId, durationId }, generateOrder = false) {
  if (!(Number(planId) > 0) || !(Number(durationId) > 0)) throw new Error('Select a valid assessment plan and duration.');
  const detail = unwrap(await api.get('/exam-courses/exam-quiz-plan-detail', { params: {
    states_id: Number(stateId) || 0,
    exam_quiz_plan_id: Number(planId),
    duration_id: Number(durationId),
    is_order_generate: generateOrder ? 1 : 0,
  } }), generateOrder ? 'Unable to create assessment order.' : 'Unable to load assessment plan details.') || {};
  if (generateOrder && !detail.vk_order_id) throw new Error('The server did not return an order ID.');
  return detail;
}

export function activeAssessmentPrice(detail) {
  const row = (detail?.subscription_price || []).find((price) => price.active === true || price.active === 1 || price.active === '1' || price.active === 'true');
  return row && Number(row.value) > 0 && Number(row.duration_id) > 0 ? row : null;
}

export async function createAssessmentItemOrder(kind, item) {
  const itemType = kind === 'quiz' ? 'quiz' : kind === 'test_series' ? 'test_series' : null;
  const itemId = Number(itemType === 'quiz' ? item?.quiz_id : item?.test_series_id);
  const amount = Number(item?.discounted_price);
  if (!itemType || !(itemId > 0) || !Number.isFinite(amount) || amount <= 0) throw new Error('This assessment item is unavailable for purchase.');
  const order = unwrap(await api.post('/subscription/generate-order', {
    order_type: 'single-item-purchase', amount: String(item.discounted_price),
    item_type: itemType, item_id: itemId, currency: 'INR',
  }), 'Unable to create assessment order.') || {};
  if (!order.vk_order_id) throw new Error('The server did not return an order ID.');
  return order;
}
